import {
  Component,
  effect,
  EventEmitter,
  inject,
  model,
  ModelSignal,
  Output,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import {
  DELETE_ACTION,
  EControlActions,
  EsvgFiles,
  IControlObject,
  INITIAL_STATE_TOKEN,
  ITableAction,
  SharedGridOptions,
  TableControlComponent,
  TableControlModule,
} from "frontier";
import AppControlGuids from "../../../../../../api/ControlGuids";
import {Observable, of} from "rxjs";
import {ICart, IPdfOverlay} from "../../../service/state.interface";
import {ProcessOverviewStore} from "../../../service/process-overview.store";
import {IPdfOverlayToggleEvent} from "../../../carts/pdf-overlay-toggle-event.interface";
import {MatSnackBar} from "@angular/material/snack-bar";
import {GridOptions} from "ag-grid-community";

@Component({
  selector: 'kpi4me-cart-document-detail',
  templateUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [TableControlModule],
  providers: [
    {provide: INITIAL_STATE_TOKEN, useValue: {filter: null}},
    {provide: TableControlComponent, useExisting: CartDocumentDetailComponent},
  ],
})
export class CartDocumentDetailComponent extends TableControlComponent {
  private _snackbar: MatSnackBar = inject(MatSnackBar);
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);
  selectedCart: Signal<ICart> = this._processOverviewService.selectedCart;
  pdfOverlay: Signal<IPdfOverlay> = this._processOverviewService.pdfOverlay;
  isPdfLoading: Signal<boolean> = this._processOverviewService.isPdfLoading;

  @Output() detailDocumentToggleTriggered: EventEmitter<IPdfOverlayToggleEvent>
    = new EventEmitter<IPdfOverlayToggleEvent>();

  override GUID: string = AppControlGuids.TCartDocumentList;
  override tableName: string = 'Auftragsdokumente';
  override gridOptions: GridOptions = {
    ...SharedGridOptions,
    rowSelection: 'single',
  };

  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    DELETE_ACTION,
    {
      displayName: (): string => {
        return this.pdfOverlay()?.type === 'detailDocument' ? 'Ausblenden' : 'Anzeigen'
      },
      controlAction: EControlActions.invoicePreview,
      disabledIfNoSelection: true,
      disabledIfMultiSelection: true,
      color: 'primary',
      icon: EsvgFiles.search,
      tooltip: 'Blende das Dokument ein.',
      tooltipDelay: 1000,
      action: () => this.toggleDetailDocumentPreview(),
      isDisabled: (): boolean => {
        return this.isPdfLoading() === true;
      },
    },
  ]);

  constructor() {
    super();
    effect((): void => {
      const selectedCart: ICart = this.selectedCart();
      if (selectedCart) {
        this.patchFilter({
          parent: selectedCart.obj,
          typename: 'cart',
        });
      }
    }, {allowSignalWrites: true});
  }

  toggleDetailDocumentPreview(): Observable<null> {
    let documentObj: IControlObject;
    this.gridApi?.getSelectedRows()[0]?.apiRow?.cols.forEach((row: any) => {
      if (row.value && typeof row.value === 'object' && row.value.type === 'TDocument') {
        documentObj = row.value;
      }
    })

    if (documentObj) {
      this.detailDocumentToggleTriggered.emit({
        type: 'detailDocument',
        data: {obj: documentObj, apiInstance: this.apiInstance()},
      });
    } else {
      this._snackbar.open('Es wurde leider kein Dokument an der Tabellenzeile gefunden.', 'ok', {
        verticalPosition: 'top',
        duration: 3000,
      });
    }

    return of(null);
  }
}
